import { render, staticRenderFns } from "./BIParameterRulesFilter.vue?vue&type=template&id=06df8cae&"
import script from "./BIParameterRulesFilter.vue?vue&type=script&lang=js&"
export * from "./BIParameterRulesFilter.vue?vue&type=script&lang=js&"
import style0 from "./BIParameterRulesFilter.vue?vue&type=style&index=0&id=06df8cae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports